import * as React from "react";
import { Reducer } from "./Reducer";
import { createControllerView } from "strikejs-react";
import { Dialog } from "../../components/ui/Dialog/Dialog";
import { SplashScreen } from "../../pages/Splashscreen/Splashscreen";
import { Button } from "../../components/ui/Button/Button";
import {
  AppProps,
  inAppState,
  WINDOW_VIEWS,
  inAppInitialState,
  AppInitState
} from "./StateAndProps";
import { ACTIONS, TYPES } from "./Actions";
import { SocialButtons } from "../../components/ui/SocialButtons/SocialButtons";
import { DialogProvider } from "../../components/ui/Dialog/DialogProvider";
import {
  SHOW_INFO_DIALOG,
  SHOW_EMBED_DIALOG
} from "../../components/ui/Dialog/Utils";
import * as _ from "lodash";
import { Footer } from "../../components/ui/Footer/Footer";
import { LinkButton } from "../../components/ui/Button/Button";
import { RES_URL } from "../../config";
import { ProtanopiaPage } from "../../pages/ProtanopiaPage/ProtanopiaPage";
import { TritanopiaPage } from "../../pages/TritanopiaPage/TritanopiaPage";
import { DeuteranopiaPage } from "../../pages/DeuteranopiaPage/DeuteranopiaPage";

export const STATE_KEY = "app";

class AppController extends React.Component<AppProps, inAppState> {
  DP: DialogProvider;
  el: HTMLDivElement;
  constructor(props) {
    super(props);
    this.state = inAppInitialState;
    this.DP = new DialogProvider();
  }

  componentDidMount() {
    let DS = this.props.dataService;
    if (DS.isDataLoaded) {
      this.props.store.dispatch(ACTIONS.DATA_LOADED(DS.getData()));
      if (this.props.routeParams.route === "/embedCode") {
        SHOW_EMBED_DIALOG(this.props.data.locale);
      }
    } else {
      DS.load().then(e => {
        this.props.store.dispatch(ACTIONS.DATA_LOADED(e));
        if (this.props.routeParams.route === "/embedCode") {
          SHOW_EMBED_DIALOG(this.props.data.locale);
        }
      });
    }
  }

  hideSplashScreen = () => {
    this.setState({ currentView: WINDOW_VIEWS.CONTENT });
  };

  render() {
    let state = this.state,
      props = this.props,
      locale = this.props.data.locale;

    const currentLang = (window as any).__LOCALE__;
    let splashHtml = { __html: locale.splashIntro };


    return (
      <div className="app-container">
        {this.props.dataService.isDataLoaded && (
          <SplashScreen
            locale={locale}
            visible={state.currentView === WINDOW_VIEWS.SPLASH}
          >
            <div className="container">
              <div className="row">
                <div className="col s12 center">
                  <div>
                    {(currentLang !== "en" && (
                      <img
                        className="campaign-logo-container splash-content__image"
                        src={RES_URL + "img/colourchange-logo-de.png"}
                        alt="Farbwechsel"
                      />
                    )) || (
                      <img
                        className="campaign-logo-container splash-content__image"
                        src={RES_URL + "img/colourchange-logo-uk.png"}
                        alt="Colour Change"
                      />
                    )}
                    <div
                      className="splashscreen-blurb"
                      dangerouslySetInnerHTML={splashHtml}
                    />
                    <div className="explore-buttons">
                      <LinkButton href="#/protanopia">
                        {locale.protanopiaButton}
                      </LinkButton>
                      <LinkButton href="#/deuteranopia">
                        {locale.deuteranopiaButton}
                      </LinkButton>
                      <LinkButton href="#/tritanopia">
                        {locale.tritanopiaButton}
                      </LinkButton>
                    </div>
                  </div>
                  <img
                    className="campaign-wave"
                    src={RES_URL + "img/desktop-wave-orig.png"}
                    alt="Colour Change"
                  />
                </div>
              </div>
            </div>
          </SplashScreen>
        )}

        <Footer locale={locale} />
      </div>
    );
  }
}

export const App = createControllerView({
  reducer: Reducer,
  propsToPropagate: ["dataService"],
  initialState: AppInitState,
  stateKey: STATE_KEY,
  component: (function() {
    return AppController;
  })()
});



// WEBPACK FOOTER //
// ./src/controllers/App/App.tsx